
    import { Component, Vue, Prop } from 'vue-property-decorator';
    import Spinner from "./Spinner.vue";
@Component({
    components: {           
        Spinner
    }        
})    
export default class LoadingSpinner extends Vue {
    @Prop({ required: true })
    waitingText!: string;

    @Prop({ required: false })
    inline!: boolean;
}
